<template>
  <div class="tags-root">
    <aside class="tags-sidebar">
      <div class="tags-sidebar-inner">
      <div
        v-for="(item, index) in sidebarItems"
        :key="item.key"
        class="accordion-group"
      >
        <div
          class="accordion-item"
          :class="{ 'is-expanded': expandedCategoryKey === item.key, 'is-active': item.hasValue }"
        >
          <button class="accordion-header" @click.stop="expandCategory(item.key)">
            <span class="filter-icon-wrap">
              <img
                v-if="getItemMeta(item).icon"
                class="filter-icon filter-icon--default"
                :src="getIconSrc(item, false)"
                alt=""
              >
              <img
                v-if="getItemMeta(item).icon"
                class="filter-icon filter-icon--active"
                :src="getIconSrc(item, true)"
                alt=""
              >
            </span>
            <span class="filter-label">
              <span class="filter-label-cn">{{ getItemMeta(item).cn }}</span>
              <span v-if="getItemMeta(item).en" class="filter-label-en">{{ getItemMeta(item).en }}</span>
            </span>
            <i class="el-icon-arrow-down accordion-arrow"></i>
          </button>
          <div v-show="expandedCategoryKey === item.key" class="accordion-panel">
            <div class="accordion-tags-grid">
              <template v-for="sonTag in getCategoryByName(item.label).son || []">
                <span
                  :key="`son_${sonTag.label_id}`"
                  class="accordion-tag"
                  :class="{
                    active: isActive(sonTag) || isExpandedSecond(item.label, sonTag),
                    'is-wide': isWideTag(sonTag)
                  }"
                  @click="handleCategoryTagClick(sonTag, item.label)"
                >{{ sonTag.label_name }}</span>
                <div
                  v-if="hasTagChildren(sonTag) && isExpandedSecond(item.label, sonTag)"
                  :key="`third_wrap_${sonTag.label_id}`"
                  class="accordion-third-tags"
                >
                  <span
                    v-for="tTag in sonTag.son"
                    :key="`third_${tTag.label_id}`"
                    class="accordion-tag third"
                    :class="{ active: isActive(tTag), 'is-wide': isWideTag(tTag) }"
                    @click="chooseThirdTag(tTag)"
                  >{{ tTag.label_name }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="index < sidebarItems.length - 1" class="filter-divider"></div>
      </div>
      </div>
    </aside>

    <div class="toolbar-filter-row">
      <div class="toolbar-filters">
      <div
        class="toolbar-filter-item"
        :class="{ 'is-open': activeDropdown === 'toolbar_sort' }"
        @mouseenter="openToolbarDropdown('toolbar_sort')"
        @mouseleave="closeToolbarDropdown"
      >
        <button type="button" class="toolbar-filter-btn">
          <span>{{ sortButtonLabel }}</span>
          <i class="el-icon-arrow-down toolbar-filter-arrow"></i>
        </button>
        <div v-show="activeDropdown === 'toolbar_sort'" class="toolbar-dropdown">
          <div
            v-for="sort in sortDisplayList"
            :key="`sort_${sort.value}`"
            class="toolbar-dropdown-item"
            :class="{ active: sortChooseValue === sort.value }"
            @click="chooseSort(sort.value)"
          >{{ sort.label }}</div>
        </div>
      </div>

      <div
        class="toolbar-filter-item"
        :class="{ 'is-open': activeDropdown === 'toolbar_duration' }"
        @mouseenter="openToolbarDropdown('toolbar_duration')"
        @mouseleave="closeToolbarDropdown"
      >
        <button type="button" class="toolbar-filter-btn">
          <span>时长</span>
          <i class="el-icon-arrow-down toolbar-filter-arrow"></i>
        </button>
        <div v-show="activeDropdown === 'toolbar_duration'" class="toolbar-dropdown">
          <div
            v-for="time in timeList"
            :key="`time_${time.value}`"
            class="toolbar-dropdown-item"
            :class="{ active: timeChooseValue === time.value }"
            @click="chooseTime(time.value)"
          >{{ time.name }}</div>
        </div>
      </div>

      <div
        class="toolbar-filter-item"
        :class="{ 'is-open': activeDropdown === 'toolbar_speed' }"
        @mouseenter="openToolbarDropdown('toolbar_speed')"
        @mouseleave="closeToolbarDropdown"
      >
        <button type="button" class="toolbar-filter-btn">
          <span>速度</span>
          <i class="el-icon-arrow-down toolbar-filter-arrow"></i>
        </button>
        <div v-show="activeDropdown === 'toolbar_speed'" class="toolbar-dropdown">
          <div
            v-for="speed in speedList"
            :key="`speed_${speed.value}`"
            class="toolbar-dropdown-item"
            :class="{ active: speedChooseValue === speed.value }"
            @click="chooseSpeed(speed.value)"
          >{{ speed.name }}</div>
        </div>
      </div>
      </div>

      <div v-if="hasSelectedFilters" class="toolbar-selected-tags">
        <el-tag
          v-for="tag in chooseTagList"
          :key="`check_${tag.label_id}`"
          size="small"
          closable
          @close="handleCloseTag(tag)"
        >{{ tag.label_name }}</el-tag>
        <el-tag
          v-if="timeChooseValue"
          size="small"
          closable
          @close="clearTime"
        >{{ toLabelName('timeChooseValue', 'timeList') }}</el-tag>
        <el-tag
          v-if="speedChooseValue"
          size="small"
          closable
          @close="clearSpeed"
        >{{ toLabelName('speedChooseValue', 'speedList') }}</el-tag>
        <span class="clean" @click="cleanTagSearch">全部清除</span>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchMusicTags } from '@/api/music'
import { orderList } from '@/config'
import { reportTagSelectDeed, getTagDisplayName } from '@/utils/deed'

const SIDEBAR_META = {
  情绪: { cn: '感受', en: 'Mood', icon: 'feel_icon' },
  风格: { cn: '流派', en: 'Genre', icon: 'style_icon' },
  配器: { cn: '配器', en: 'Ins', icon: 'tool_icon' },
  场景: { cn: '场景', en: 'Scene', icon: 'scene_icon' },
  时长: { cn: '时长', en: 'Length', iconType: 'clock' },
  速度: { cn: 'BPM', en: '', iconType: 'bpm' }
}

export default {
  name: 'NewMusicListTagsFilterNew',
  data() {
    return {
      tagsList: [],
      chooseTagList: [],
      expandedSecond: {},
      expandedCategoryKey: null,
      wideTagIdMap: {},
      activeDropdown: null,
      timeChooseValue: '',
      speedChooseValue: '',
      sortChooseValue: '',
      orderList,
      timeList: [{
        name: '全部',
        value: '',
      }, {
        name: '小于30秒',
        value: 1,
      }, {
        name: '30秒-1分钟',
        value: 2,
      }, {
        name: '1分钟-2分钟',
        value: 3,
      }, {
        name: '2分钟-3分钟',
        value: 4,
      }, {
        name: '3分钟以上',
        value: 5,
      }],
      speedList: [{
        name: '全部',
        value: '',
      }, {
        name: '慢（BPM 0～60）',
        value: 1,
      }, {
        name: '中（BPM 60～100）',
        value: 2,
      }, {
        name: '快（BPM 100以上）',
        value: 3,
      }]
    }
  },
  props: {
    pager: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    sidebarItems() {
      const buildCategoryItem = (cat) => ({
        key: `cat_${cat.label_id}`,
        label: cat.label_name,
        type: 'category',
        hasValue: this.chooseTagList.some(tag =>
          (cat.son || []).some(son =>
            son.label_id === tag.label_id ||
            (son.son || []).some(child => child.label_id === tag.label_id)
          )
        )
      })

      const items = []
      const mood = this.tagsList.find(tag => tag.label_name === '情绪')
      const genre = this.tagsList.find(tag => tag.label_name === '风格')
      const ins = this.tagsList.find(tag => tag.label_name === '配器')
      const scene = this.tagsList.find(tag => tag.label_name === '场景')

      if (mood) items.push(buildCategoryItem(mood))
      if (genre) items.push(buildCategoryItem(genre))
      if (ins) items.push(buildCategoryItem(ins))
      if (scene) items.push(buildCategoryItem(scene))

      return items
    },
    sortDisplayList() {
      const order = ['', 2, 1]
      return order
        .map(value => this.orderList.find(item => item.value === value))
        .filter(Boolean)
    },
    sortButtonLabel() {
      const current = this.orderList.find(item => item.value === this.sortChooseValue)
      if (!current || current.value === '') return '排序'
      return current.label
    },
    hasSelectedFilters() {
      return this.chooseTagList.length > 0 || this.timeChooseValue || this.speedChooseValue
    }
  },
  created() {
    this.getTagList()
  },
  beforeDestroy() {
    if (this._tagMeasureEl && this._tagMeasureEl.parentNode) {
      this._tagMeasureEl.parentNode.removeChild(this._tagMeasureEl)
      this._tagMeasureEl = null
    }
  },
  methods: {
    getItemMeta(item) {
      return SIDEBAR_META[item.label] || { cn: item.label, en: '' }
    },
    getIconSrc(item, active = false) {
      const meta = this.getItemMeta(item)
      if (!meta.icon) return ''
      const iconName = active
        ? meta.icon.replace(/_icon$/, '_select_icon')
        : meta.icon
      return require(`@/assets/svg/tag/${iconName}.svg`)
    },
    getCategoryByName(name) {
      return this.tagsList.find(tag => tag.label_name === name) || { son: [] }
    },
    expandCategory(key) {
      const nextKey = this.expandedCategoryKey === key ? null : key
      this.expandedCategoryKey = nextKey
      if (!nextKey) return
      const item = this.sidebarItems.find(i => i.key === nextKey)
      if (item) this.measureWideTagsForCategory(item.label)
    },
    openToolbarDropdown(key) {
      this.activeDropdown = key
    },
    closeToolbarDropdown() {
      this.activeDropdown = null
    },
    getTagMeasureEl() {
      if (!this._tagMeasureEl) {
        const el = document.createElement('span')
        el.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0;padding:0;margin:0;border:0;'
        document.body.appendChild(el)
        this._tagMeasureEl = el
      }
      return this._tagMeasureEl
    },
    getTextMeasureWidth(text, isThird) {
      const el = this.getTagMeasureEl()
      el.style.fontSize = isThird ? '12px' : '13px'
      el.style.fontFamily = window.getComputedStyle(document.body).fontFamily
      el.textContent = text || ''
      return el.offsetWidth
    },
    measureWideTagsForCategory(categoryName) {
      const CELL_WIDTH = 80
      const category = this.getCategoryByName(categoryName)
      const map = { ...this.wideTagIdMap }
      ;(category.son || []).forEach(son => {
        map[son.label_id] = this.getTextMeasureWidth(son.label_name, false) > CELL_WIDTH
        ;(son.son || []).forEach(child => {
          map[child.label_id] = this.getTextMeasureWidth(child.label_name, true) > CELL_WIDTH
        })
      })
      this.wideTagIdMap = map
    },
    isWideTag(tag) {
      return !!this.wideTagIdMap[tag.label_id]
    },
    hasTagChildren(tag) {
      return !!(tag.son && tag.son.length)
    },
    isActive(tag) {
      return this.chooseTagList.some(t => t.label_id === tag.label_id)
    },
    isExpandedSecond(categoryName, tag) {
      const key = `${categoryName}_${tag.label_id}`
      return !!this.expandedSecond[key]
    },
    handleCategoryTagClick(tag, categoryName) {
      if (this.hasTagChildren(tag)) {
        const key = `${categoryName}_${tag.label_id}`
        this.$set(this.expandedSecond, key, !this.expandedSecond[key])
        return
      }
      const index = this.chooseTagList.findIndex(i => i.label_id === tag.label_id)
      if (index > -1) {
        this.chooseTagList.splice(index, 1)
      } else {
        this.chooseTagList.push(tag)
      }
      this.reportCurrentTagSelection()
      this.handleGet()
    },
    chooseThirdTag(tag) {
      const index = this.chooseTagList.findIndex(i => i.label_id === tag.label_id)
      if (index > -1) {
        this.chooseTagList.splice(index, 1)
      } else {
        this.chooseTagList.push(tag)
      }
      this.reportCurrentTagSelection()
      this.handleGet()
    },
    chooseTime(v) {
      if (this.timeChooseValue !== v) {
        this.timeChooseValue = v
        this.handleGet()
      }
      this.activeDropdown = null
    },
    chooseSpeed(v) {
      if (this.speedChooseValue !== v) {
        this.speedChooseValue = v
        this.handleGet()
      }
      this.activeDropdown = null
    },
    chooseSort(v) {
      if (this.sortChooseValue !== v) {
        this.sortChooseValue = v
        this.handleGet()
      }
      this.activeDropdown = null
    },
    clearTime() {
      this.timeChooseValue = ''
      this.handleGet()
    },
    clearSpeed() {
      this.speedChooseValue = ''
      this.handleGet()
    },
    toLabelName(key, listKey) {
      const index = this[listKey].findIndex(i => i.value === this[key])
      return this[listKey][index].name
    },
    handleCloseTag(item) {
      const index = this.chooseTagList.findIndex(i => i.label_id === item.label_id)
      this.chooseTagList.splice(index, 1)
      this.handleGet()
    },
    cleanTagSearch() {
      this.timeChooseValue = ''
      this.speedChooseValue = ''
      this.chooseTagList = []
      this.expandedSecond = {}
      this.activeDropdown = null
      this.handleGet()
    },
    handleGet() {
      this.$emit('getList', {
        bpm: this.speedChooseValue,
        duration: this.timeChooseValue,
        order: this.sortChooseValue,
        label_id: this.chooseTagList.map(i => i.label_id).join(',')
      })
    },
    async getTagList() {
      try {
        const { data } = await fetchMusicTags()
        this.tagsList = data
      } catch (e) {
        console.error('Failed to load tags:', e)
      }
    },
    reportCurrentTagSelection() {
      reportTagSelectDeed(this.chooseTagList.map(getTagDisplayName))
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-root {
  display: contents;
}

.tags-sidebar {
  grid-column: 1;
  grid-row: 1 / -1;
  width: 200px;
  align-self: stretch;
  z-index: 10;
  padding: 0 16px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

.tags-sidebar-inner {
  position: sticky;
  top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 16px;
}

.accordion-group {
  width: 100%;
  max-width: 168px;
}

.accordion-item {
  width: 100%;

  &.is-expanded {
    .accordion-arrow {
      transform: rotate(180deg);
    }

    .accordion-header,
    .filter-label-cn,
    .filter-label-en,
    .accordion-arrow {
      color: #E52A0D;
    }
  }

  &.is-active:not(.is-expanded) {
    .accordion-header,
    .filter-label-cn,
    .filter-label-en {
      color: #2DB8B9;
    }

    .accordion-arrow {
      color: #2DB8B9;
    }
  }
}

.accordion-header {
  width: 100%;
  min-height: 44px;
  padding: 8px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  text-align: left;

  &:hover {
    .filter-label-cn,
    .filter-label-en,
    .accordion-arrow {
      color: #E52A0D;
    }
  }
}

.accordion-arrow {
  flex-shrink: 0;
  font-size: 12px;
  color: #999;
  transition: transform 0.2s;
}

.accordion-panel {
  width: 100%;
  padding: 4px 0 12px;
  box-sizing: border-box;
}

.accordion-tags-grid {
  display: grid;
  grid-template-columns: repeat(2, 80px);
  column-gap: 8px;
  row-gap: 8px;
  justify-content: center;
}

.accordion-third-tags {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(2, 80px);
  column-gap: 8px;
  row-gap: 8px;
  justify-content: center;
}

.accordion-tag {
  width: 80px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 4px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  background: #EBEBEB;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;

  &:hover {
    background: #E52A0D;
    color: #fff;
  }

  &.active {
    background: #E52A0D;
    color: #fff;
  }

  &.third {
    font-size: 12px;
  }

  &.is-wide {
    grid-column: 1 / -1;
    width: 100%;
  }
}

.filter-icon-wrap {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.filter-icon {
  width: 20px;
  height: 20px;
  display: block;

  &--active {
    display: none;
    position: absolute;
  }
}

.accordion-item.is-expanded,
.accordion-header:hover {
  .filter-icon--default {
    display: none;
  }

  .filter-icon--active {
    display: block;
    position: static;
  }
}

.filter-label {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 4px;
  line-height: 1.2;
}

.filter-label-cn {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.filter-label-en {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}

.filter-divider {
  width: 100%;
  height: 1px;
  margin: 6px 0;
  background: #E8E8E8;
}

.toolbar-filter-row {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 44px;
  padding: 16px 0 12px 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

.toolbar-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.toolbar-filter-item {
  position: relative;
  flex-shrink: 0;

  &.is-open .toolbar-filter-arrow {
    transform: rotate(180deg);
  }
}

.toolbar-filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  outline: none;
  white-space: nowrap;

  &:hover {
    border-color: rgba(0, 0, 0, 0.2);
  }
}

.toolbar-filter-arrow {
  font-size: 12px;
  color: #999;
  transition: transform 0.2s;
}

.toolbar-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 120px;
  padding: 4px 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 20;

  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: 0;
    right: 0;
    height: 4px;
  }
}

.toolbar-dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #FDF4F3;
    color: #E52A0D;
  }

  &.active {
    background: #E52A0D;
    color: #fff;
  }
}

.toolbar-selected-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: 20px;

  .el-tag {
    border-radius: 12px;
    font-size: 13px;
    cursor: pointer;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.85);
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .clean {
    font-size: 12px;
    color: #4d4d4f;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: #E52A0D;
    }
  }
}
</style>
